import { Button } from '@/components/ui/button'

export const Paginator = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
  variant = 'buttons', // 'buttons' | 'dots'
}: {
  totalItems: number
  itemsPerPage: number
  currentPage: number
  onPageChange: (page: number) => void
  variant?: 'buttons' | 'dots'
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage)

  if (totalPages <= 1) return null

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1)

  if (variant === 'dots') {
    return (
      <div className="flex justify-center mt-4 gap-2">
        {pages.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`w-3 h-3 md:w-4 md:h-4 rounded-full transition-all
              ${
                page === currentPage
                  ? 'bg-green-500 dark:bg-green-300'
                  : 'bg-gray-300 dark:bg-gray-500'
              }`}
          />
        ))}
      </div>
    )
  }

  return (
    <div className="flex justify-center mt-4 gap-2 flex-wrap">
      {pages.map((page) => (
        <Button
          key={page}
          size="sm"
          variant={'outline'}
          className={`${
            page === currentPage ? 'gradient-bg-affirmative text-white hover:text-white' : ''
          }`}
          onClick={() => onPageChange(page)}
        >
          {page}
        </Button>
      ))}
    </div>
  )
}
